import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  rating: number;
  title: string;
  content: string;
  author: string;
  location: string;
}
export function TestimonialCard({
  rating,
  title,
  content,
  author,
  location
}: TestimonialCardProps) {
  return <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-435">
      <div className="flex gap-1 mb-3" data-id="element-436">
        {[...Array(rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-437" />)}
      </div>
      <h4 className="font-bold text-gray-900 mb-3 text-lg" data-id="element-438">{title}</h4>
      <p className="text-gray-700 leading-relaxed mb-4" data-id="element-439">{content}</p>
      <p className="text-sm text-gray-600 font-medium" data-id="element-440">
        — {author}, {location} |{' '}
        <span className="text-green-600" data-id="element-441">Verified Buyer</span>
      </p>
    </div>;
}